import { render, staticRenderFns } from "./ButtonSort.vue?vue&type=template&id=22ea5cae&"
import script from "./ButtonSort.vue?vue&type=script&lang=ts&"
export * from "./ButtonSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports